import { Injectable } from '@angular/core';
// import {Router} from '@angular/router';
import { Router } from '@angular/router';
import { DashboardService } from '../component/protect-component/AdviserComponent/dashboard/dashboard.service';
import { SupportService } from '../component/protect-component/SupportComponent/support.service'


import * as CryptoJS from 'crypto-js';
import { jwtDecode } from 'jwt-decode';
import { environment } from 'src/environments/environment';
import { apiConfig } from '../config/main-config';
import { BehaviorSubject, Subject } from 'rxjs';
import { EnumDataService } from '../services/enum-data.service';
@Injectable()
export class AuthService {
  public static hostName;
  static production = apiConfig.PRODUCTION;
  static readonly secretKeyS = 'myplannerFuturewise@0987*';
  public masterKey = 'ifanowMsTrSEcRet';

  constructor(
    private router: Router, private enumDataService: EnumDataService
  ) {
  }

  get orgData() {
    return JSON.parse(localStorage.getItem('orgData')) || {};
  }

  get profilePic() {
    return localStorage.getItem('profilePic');
  }

  get clientProfilePic() {
    return sessionStorage.getItem('clientProfilePic');
  }

  get appPic() {
    const orgData = JSON.parse(localStorage.getItem('orgData'));
    return orgData ? orgData.logoUrl : '';
  }
  familyMemberId: any;

  selectedClient: any;

  isAdvisorLogin = new BehaviorSubject<boolean>(this.isAdvisor());
  isAdvisorLogin$ = this.isAdvisorLogin.asObservable();
  private logoutSubject = new Subject<void>();
  logout$ = this.logoutSubject.asObservable();

  static getAdminStatus() {
    if (this.getUserInfo().hasOwnProperty('isAdmin')) {
      return this.getUserInfo().isAdmin;
    } else {
      return false;
    }
  }

  static getUserInfo() {
    return JSON.parse(localStorage.getItem('userInfo'));
  }

  static getAdvisorId() {
    return this.getUserInfo().advisorId;
  }

  static getAdminAdvisorId() {
    const adminid = this.getUserInfo().adminAdvisorId;
    if (adminid > 0) {
      return adminid;
    } else {
      return this.getUserInfo().advisorId;
    }
  }

  static getParentId() {
    return this.getUserInfo().parentId;
  }

  static getAdminId() {
    let adminAdvisorId = this.getUserInfo().adminAdvisorId;
    if (!adminAdvisorId || adminAdvisorId == 0) {
      adminAdvisorId = this.getAdvisorId();
    }
    return adminAdvisorId;
  }

  static getRmId() {
    if (this.getUserInfo().hasOwnProperty('rmId')) {
      return this.getUserInfo().rmId;
    } else {
      return null;
    }
  }

  static setInvalidCredsTimeZone(data) {
    sessionStorage.setItem('invalidPopup', JSON.stringify(data));
  }

  static setToDoList(data) {
    sessionStorage.setItem('ToDo', JSON.stringify(data));
  }

  static setClientRolesSettings(data) {
    sessionStorage.setItem('clientRoles', JSON.stringify(data));
  }

  static setAdvisorRolesSettings(data) {
    localStorage.setItem('advisorRoles', JSON.stringify(data));
  }

  static setTeamMemberRolesSettings(data) {
    localStorage.setItem('teamMemberRoles', JSON.stringify(data));
  }

  static setUserRoleType(roleObj) {
    localStorage.setItem('roleObj', JSON.stringify(roleObj));
  }


  static getInvalidCredsTimeZone() {
    return JSON.parse(sessionStorage.getItem('invalidPopup'));
  }

  static getToDo() {
    return JSON.parse(sessionStorage.getItem('ToDo'));
  }

  static getUserRoleType() {
    const roleObj = localStorage.getItem('roleObj');
    return roleObj ? JSON.parse(roleObj) : {};
  }

  static getUserId() {
    return this.getUserInfo().userId;
  }

  static getClientData() {
    const clientDataString = localStorage.getItem('clientData');
    return clientDataString ? JSON.parse(clientDataString) : undefined;
  }

  static getProfileDetails() {
    const clientDataString = localStorage.getItem('profileData');
    return clientDataString ? JSON.parse(clientDataString) : undefined;
  }

  static getOrgDetails() {
    const orgData = localStorage.getItem('orgData');
    return orgData ? JSON.parse(orgData) : undefined;
  }


  static getClientId() {
    const clientData = this.getClientData();
    return clientData ? clientData.clientId ? clientData.clientId : clientData.id : undefined;
  }

  static setProfilePic(pic) {
    localStorage.setItem('profilePic', pic);
  }

  static setClientProfilePic(pic) {
    sessionStorage.setItem('clientProfilePic', pic);
  }

  static setOrgDetails(data) {
    localStorage.setItem('orgData', JSON.stringify(data));
  }

  static setAdvisorDetails(data) {
    localStorage.setItem('advisorDetail', JSON.stringify(data));
  }

  static setDomainDetails(data) {
    localStorage.setItem('domainDetails', JSON.stringify(data));
  }

  static getAdvisorDetails() {
    const advisorDetail = localStorage.getItem('advisorDetail');
    return advisorDetail ? JSON.parse(advisorDetail) : '';
  }

  static getClientRoles(data) {
    return sessionStorage.getItem('clientRoles');
  }

  static getAdvisorRoles() {
    const clientDataString = localStorage.getItem('advisorRoles');
    return clientDataString ? JSON.parse(clientDataString) : undefined;
  }

  static getTeamMemberRoles(data) {
    return localStorage.getItem('teamMemberRoles');

  }

  static getDomainDetails() {
    return JSON.parse(localStorage.getItem('domainDetails'));
  }

  static setRefreshedOnce(refreshedOnce) {
    sessionStorage.setItem('refreshedOnce', refreshedOnce);
  }

  static isRefreshedOnce() {
    return sessionStorage.getItem('refreshedOnce');
  }

  static setSubscriptionUpperSliderData(data) {
    sessionStorage.setItem('subUpperData', JSON.stringify(data));
  }

  // getSelectedClient(){
  //   return this.selectedClient;
  // }

  static getSubscriptionUpperSliderData() {
    return JSON.parse(sessionStorage.getItem('subUpperData'));
  }

  static goHome(router: Router) {
    const userInfo = AuthService.getUserInfo();
    if (userInfo.userType == 1 || userInfo.userType == 8) {
      router.navigate(['admin', 'dashboard']);
    } else if (userInfo.isRmLogin) {
      router.navigate(['support', 'dashboard']);
    } else {
      router.navigate(['customer', 'detail', 'overview', 'myfeed']);
    }
  }

  setToken(token: string) {
    localStorage.setItem('token', token);
  }

  getToken() {
    return localStorage.getItem('token');
  }
  getTokenSignUp() {
    return localStorage.getItem('tokenSignUp');
  }
  isLoggedIn() {
    return this.getToken() != null && this.getToken() != undefined;
  }

  isAdvisor() {
    if (AuthService.getUserInfo()) {
      return AuthService.getUserInfo().userType ? AuthService.getUserInfo().userType === 1 || AuthService.getUserInfo().userType === 8 : false;
    } else {
      return false;
    }
  }

  logout() {
    this.logoutSubject.next();
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('clientData');
    sessionStorage.removeItem('clientData');
    localStorage.removeItem('profilePic');
    localStorage.removeItem('orgData');
    localStorage.removeItem('advisorDetail');
    localStorage.removeItem('roleObj');
    localStorage.removeItem('successStoringToken');
    localStorage.removeItem('googleOAuthToken');
    localStorage.removeItem('advisorRoles');
    window.name = undefined;
    localStorage.clear();
    sessionStorage.removeItem('ToDo');
    sessionStorage.clear();
    sessionStorage.removeItem('taskMatrix');
    sessionStorage.removeItem('todaysTaskList');
    sessionStorage.removeItem('invalidPopup');
    DashboardService.clearDashData();
    SupportService.clearData()
    this.isAdvisorLogin.next(false);
    this.enumDataService.setAdvisorPopupValue(false);  // Notify AppComponent


    // this.myRoute.navigate(['login']);
  }

  setUserInfo(info) {
    this.isAdvisorLogin.next(true);
    localStorage.setItem('userInfo', JSON.stringify(info));
  }

  setProfileDetails(profileData) {
    sessionStorage.setItem('profileData', JSON.stringify(profileData));
    localStorage.setItem('profileData', JSON.stringify(profileData));

  }

  setClientData(clientData) {
    sessionStorage.setItem('clientData', JSON.stringify(clientData));
    if (clientData.familyMemberId) {
      this.familyMemberId = clientData.familyMemberId;
    }
    clientData.familyMemberId = this.familyMemberId;
    localStorage.setItem('clientData', JSON.stringify(clientData));

    // if(clientData){
    //   this.selectedClient = clientData;
    // }
  }

  /* --------- Jwt Token By Mrityunjay ----------- */

  static stringDecrypt(encryptedData): any {
    if (this.production) {
      encryptedData = encryptedData ? encryptedData : '';
      try {
        const bytes = CryptoJS.AES.decrypt(encryptedData, this.secretKeyS);
        if (bytes.toString()) {
          return bytes.toString(CryptoJS.enc.Utf8);
        }
      } catch (error) {
        return null;
      }
    } else {
      try {
        return encryptedData;
      } catch (error) {
        const bytes = CryptoJS.AES.decrypt(encryptedData, this.secretKeyS);
        if (bytes.toString()) {
          return bytes.toString(CryptoJS.enc.Utf8);
        }
      }
    }
  }

  static encrypt(data: any) {
    if (this.production) {
      const encryptedData = CryptoJS.AES.encrypt(data, this.secretKeyS);
      return encryptedData.toString();
    } else {
      return data;
    }
  }

  setJwtToken(token: string) {
    const encryptedData = AuthService.encrypt(token);
    localStorage.setItem('jwtToken', encryptedData);
  }

  getJwtToken() {
    return AuthService.stringDecrypt(localStorage.getItem('jwtToken'));
    // return localStorage.getItem('token');
  }

  getDecryptedKey() {
    return AuthService.stringDecrypt(localStorage.getItem('decryptedKey'));
  }
}
